export default "__VITE_ASSET__DvnTyTVm__"